import ApiConstants from '../../constants/ApiConstants';
import xhr from './xhr';
import { assertUUID } from '../uuid';

const PlacementApiUtils = {
  fetchOneByStudentId(id) {
    // const query = `?locale=${locale}`;
    return xhr(`${ApiConstants.FetchPlacement}/${id}`);
  },

  create(studentId, levelId) {
    // Guard against accidentally parsing UUIDs as numbers
    assertUUID(studentId, 'studentId');
    assertUUID(levelId, 'levelId');

    return xhr(ApiConstants.SetPlacement, {
      method: 'post',
      body: JSON.stringify({
        level_id: levelId,
        student_id: studentId,
      }),
    });
  },

  update(studentId, levelId) {
    // Guard against accidentally parsing UUIDs as numbers
    assertUUID(studentId, 'studentId');
    assertUUID(levelId, 'levelId');

    return xhr(ApiConstants.UpdatePlacement, {
      method: 'put',
      body: JSON.stringify({
        level_id: levelId,
        student_id: studentId,
      }),
    });
  },
};

export default PlacementApiUtils;
